let TableControllerAction = {
    PREVIOUS: 0,
    NEXT: 1
}
export default TableControllerAction;